import { Paper } from '../types';
import RiskBadge from './RiskBadge';

interface AuditStatusBadgeProps {
  paper: Paper;
}

/**
 * Display dual status for a paper:
 * 1. Audit progress (审查进度)
 * 2. Risk level (风险等级) - only shown when completed
 */
function AuditStatusBadge({ paper }: AuditStatusBadgeProps) {
  const { audit_status, audit_risk_level } = paper;

  // Determine progress badge
  let progressBadge: React.ReactNode;
  if (!audit_status || audit_status === 'none') {
    progressBadge = (
      <span className="px-2 py-0.5 text-xs bg-gray-100 text-gray-500 rounded-full">
        未审查
      </span>
    );
  } else if (audit_status === 'running') {
    progressBadge = (
      <span className="flex items-center px-2 py-0.5 text-xs bg-blue-50 text-blue-600 rounded-full">
        <span className="animate-spin rounded-full h-2 w-2 border-b-2 border-blue-600 mr-1"></span>
        审查中
      </span>
    );
  } else if (audit_status === 'pending') {
    progressBadge = (
      <span className="px-2 py-0.5 text-xs bg-yellow-50 text-yellow-600 rounded-full">
        等待中
      </span>
    );
  } else if (audit_status === 'failed') {
    progressBadge = (
      <span className="px-2 py-0.5 text-xs bg-red-50 text-red-600 rounded-full">
        审查失败
      </span>
    );
  } else if (audit_status === 'completed') {
    progressBadge = (
      <span className="px-2 py-0.5 text-xs bg-green-50 text-green-600 rounded-full">
        审查完毕
      </span>
    );
  } else {
    progressBadge = (
      <span className="px-2 py-0.5 text-xs bg-gray-100 text-gray-500 rounded-full">
        已审查
      </span>
    );
  }

  // Show risk level only when audit is completed
  const showRiskLevel = audit_status === 'completed' && audit_risk_level;

  return (
    <div className="flex items-center space-x-2">
      {/* First: Audit progress */}
      {progressBadge}

      {/* Second: Risk level (only when completed) */}
      {showRiskLevel && <RiskBadge level={audit_risk_level} size="sm" />}
    </div>
  );
}

export default AuditStatusBadge;
